import { Empty, PageHeader, Popconfirm, Tooltip, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { TableItem, ButtonItem } from "../../../Components/Items";
import moment from "moment";
import "moment/locale/es";
import { CheckCircleOutlined, EditOutlined, StopOutlined } from "@ant-design/icons";
import AgregarSubProyecto from "./AgregarSubProyecto/AgregarSubProyecto";
import EditarSubProyecto from "./EditarSubProyecto/EditarSubProyecto";

moment.locale("es");

class SubProyectos extends Component {
  state = {
    modalAgregar: false,
    modalEditar: false,
    todosSubProyectos: [],
    loading: false,
    subProyectoSeleccionado: null,
  };

  // Abrir modal para agregar
  abrirAgregarSubProyecto = () => {
    this.setState({ modalAgregar: true, subProyectoSeleccionado: null });
  };

  // Cerrar modal de agregar
  cerrarAgregarSubProyecto = () => {
    this.setState({ modalAgregar: false });
    this.consultarTodosSubProyectos();
  };

  // Abrir modal para editar
  abrirEditarSubProyecto = (subProyecto) => {
    this.setState({ modalEditar: true, subProyectoSeleccionado: subProyecto });
  };

  // Cerrar modal de editar
  cerrarEditarSubProyecto = () => {
    this.setState({ modalEditar: false });
    this.consultarTodosSubProyectos();
  };

  componentDidMount() {
    this.consultarTodosSubProyectos();
  }

  consultarTodosSubProyectos() {
    this.setState({ loading: true });
    axios
      .post(
        "subProyectos/selectTodosSubProyectos",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.status === 404) {
          message.error("No se encontraron subproyectos");
        } else {
          this.setState({
            todosSubProyectos: res.data.subProyectos.map((value) => {
              return { ...value, accion: { _id: value._id, estado: value.estado } };
            }),
          });
        }
      });
  }

  // Deshabilita un subproyecto
  deshabilitarSubProyecto(id) {
    axios
      .post(
        "subProyectos/deshabilitarSubProyecto",
        { subProyectoId: id },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Subproyecto deshabilitado exitosamente");
          this.consultarTodosSubProyectos();
        } else if (res.data.success === 1){
          message.error("Error al deshabilitar el subproyecto");
        } else {
          message.error("Error");
        }
      });
  }

  // Habilita un subproyecto
  habilitarSubProyecto(id) {
    axios
      .post(
        "subProyectos/habilitarSubProyecto",
        { subProyectoId: id },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Subproyecto habilitado exitosamente");
          this.consultarTodosSubProyectos();
        } else if (res.data.success === 1){
          message.error("Error al habilitar el subproyecto");
        } else {
          message.error("Error");
        }
      });
  }

  render() {
    const columns = [
      {
        title: "Código",
        dataIndex: "codigo",
        key: "codigo",
        sorter: (a, b) => a.codigo.localeCompare(b.codigo),
      },
      {
        title: "Nombre",
        dataIndex: "nombre",
        key: "nombre",
        sorter: (a, b) => a.nombre.localeCompare(b.nombre),
      },
      {
        title: "Descripción",
        dataIndex: "descripcion",
        key: "descripcion",
        sorter: (a, b) => a.descripcion.localeCompare(b.descripcion),
      },
      {
        title: "Acción",
        key: "accion",
        align: "center",
        onHeaderCell: () => ({
          style: { textAlign: 'center', padding: '4px' }
        }),
        onCell: () => ({
          className: "acciones-sin-hover",
          style: { textAlign: 'center', padding: '4px' }
        }),
        render: (record) => {
          let buttons = [];

          // Botón Editar
          buttons.push(
            <Tooltip title="Editar SubProyecto" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
              <ButtonItem
                key={`editar-${record._id}`}
                type="default"
                size="small"
                cyan
                icon={<EditOutlined />}
                onClick={() => this.abrirEditarSubProyecto(record)}
              >
              </ButtonItem>
            </Tooltip>
          );

          // Botón Habilitar/Deshabilitar
          if (record.estado === 1) {
            buttons.push(
              <Popconfirm
                key={`deshabilitar-${record._id}`}
                title="¿Seguro que quieres deshabilitar este subproyecto?"
                onConfirm={() => this.deshabilitarSubProyecto(record._id)}
                okText="Sí"
                cancelText="No"
              >
                <Tooltip title="Deshabilitar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                  <ButtonItem
                    type="default"
                    size="small"
                    lima
                    icon={<CheckCircleOutlined />}
                  >
                  </ButtonItem>
                </Tooltip>
              </Popconfirm>
            );
          } else {
            buttons.push(
              <Popconfirm
                key={`habilitar-${record._id}`}
                title="¿Seguro que quieres habilitar este subproyecto?"
                onConfirm={() => this.habilitarSubProyecto(record._id)}
                okText="Sí"
                cancelText="No"
              >
                <Tooltip title="Habilitar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                  <ButtonItem
                    type="default"
                    size="small"
                    rojo
                    icon={<StopOutlined />}
                  >
                  </ButtonItem>
                </Tooltip>
              </Popconfirm>
            );
          }

          return <div className="acciones-container">{buttons}</div>;
        },
      },
    ];

    return (
      <>
        <PageHeader
          title="SubProyectos"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <ButtonItem
              type="primary"
              key="agregarSubProyecto"
              olivo
              onClick={this.abrirAgregarSubProyecto}
               className="botonAgregar"
            >
              Agregar SubProyecto
            </ButtonItem>
          }
        />
        <TableItem
          locale={{
            emptyText: (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={
                  <>
                    <p>No hay registros de subproyectos. Aquí puedes gestionar y llevar un control de los subproyectos.</p>
                  </>
                }
              />
            ),
          }}
          loading={this.state.loading}
          size="small"
          dataSource={this.state.todosSubProyectos}
          columns={columns}
          pagination={false}
        />
        <AgregarSubProyecto
          visible={this.state.modalAgregar}
          cerrarModal={this.cerrarAgregarSubProyecto}
          subProyecto={this.state.subProyectoSeleccionado}
        />
        <EditarSubProyecto
          visible={this.state.modalEditar}
          cerrarModal={this.cerrarEditarSubProyecto}
          subProyecto={this.state.subProyectoSeleccionado}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(SubProyectos);
